var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.categories),function(cat){return _c('div',{key:cat.id},[_c('h2',[_vm._v(_vm._s(cat.name))]),_c('p',{domProps:{"innerHTML":_vm._s(cat.text)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }